export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/PA-753c48c91fbd0f6d8fc387ba95097bba.png";